/**
 * Единый источник auth-конфига мини-аппа — allowlist владельцев, guest-скоуп,
 * open-access-флаг. Работает и на сервере, и на клиенте (никаких node-only
 * API): на клиенте GATE_ALLOWED_IDS не инлайнится Next.js и читается как
 * undefined — используем NEXT_PUBLIC_ALLOWED_IDS.
 */

function parseIds(raw: string): number[] {
  return raw.split(",").map((id) => parseInt(id.trim(), 10)).filter((id) => !isNaN(id));
}

/** Владельцы: сервер предпочитает GATE_ALLOWED_IDS, иначе — публичный
 *  NEXT_PUBLIC_ALLOWED_IDS (тот же список, что видит клиент). */
export function getAllowedIds(): number[] {
  return parseIds(process.env.GATE_ALLOWED_IDS || process.env.NEXT_PUBLIC_ALLOWED_IDS || "");
}

/** Гости: видят только Vova's flow (/agents/flow?session=vova). */
export function getGuestIds(): number[] {
  return parseIds(process.env.NEXT_PUBLIC_GUEST_IDS || "");
}

/** Публичный деплой: любой Telegram-юзер с подписью проходит, контент — по
 *  active-тенанту. */
export function isOpenAccess(): boolean {
  return process.env.NEXT_PUBLIC_OPEN_ACCESS === "1";
}

/** userId входит в allowlist владельцев (принимает number|string — HMAC- и
 *  клиентские кол-сайты передают разные типы). */
export function isAllowed(userId: number | string): boolean {
  const id = typeof userId === "string" ? parseInt(userId, 10) : userId;
  return !isNaN(id) && getAllowedIds().includes(id);
}
